var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.875C20.8644 1.875 25.625 6.63563 25.625 12.5C25.625 15.5538 24.1013 18.6969 22.1881 21.3363C19.5169 25.0225 16.1762 27.71 16.1762 27.71V27.7106C15.4894 28.2631 14.5106 28.2631 13.8238 27.7106V27.71C13.8238 27.71 10.4831 25.0225 7.81187 21.3363C5.89875 18.6969 4.375 15.5538 4.375 12.5C4.375 6.63563 9.13562 1.875 15 1.875ZM15 8.125C17.4144 8.125 19.375 10.0856 19.375 12.5C19.375 14.9144 17.4144 16.875 15 16.875C12.5856 16.875 10.625 14.9144 10.625 12.5C10.625 10.0856 12.5856 8.125 15 8.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3859740f81bbb3370cc9ce61805be220.svg";
export { ForwardRef as ReactComponent };